module.exports = __webpack_public_path__ + "img/roles.d6ab9335.svg";